"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionChangeIcon = OptionChangeIcon;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _translations = require("../helpers/translations");

var _styles = require("@mui/material/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
*
* OptionChangeIcon Component
*
*/
function OptionChangeIcon(_ref) {
  var color = _ref.color,
      width = _ref.width;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46 46",
    width: width || '28px'
  }, /*#__PURE__*/_react["default"].createElement("title", null, (0, _translations.getTranslations)('btn_option_change')), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "23",
    cy: "23",
    r: "15",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "23",
    cy: "23",
    r: "15.91549430918954",
    fill: "transparent",
    stroke: (0, _styles.lighten)(color, 0.8),
    strokeWidth: "13"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "23",
    cy: "23",
    r: "15.91549430918954",
    fill: "transparent",
    stroke: (0, _styles.lighten)(color, 0.6),
    strokeWidth: "13",
    strokeDasharray: "85 15",
    strokeDashoffset: "25"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "23",
    cy: "23",
    r: "15.91549430918954",
    fill: "transparent",
    stroke: (0, _styles.lighten)(color, 0.4),
    strokeWidth: "13",
    strokeDasharray: "60 40",
    strokeDashoffset: "25"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "23",
    cy: "23",
    r: "15.91549430918954",
    fill: "transparent",
    stroke: color,
    strokeWidth: "13",
    strokeDasharray: "50 50",
    strokeDashoffset: "25"
  }));
}

OptionChangeIcon.propTypes = {
  color: _propTypes["default"].string,
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
var _default = OptionChangeIcon;
exports["default"] = _default;